export const zones = ['main_entry', 'appliances', 'tv_entertainment', 'smart_home', 'computers', 'video_games'];
export const zoneMap = {
  'main_entry': 'Main Entry',
  'appliances': 'Appliances',
  'tv_entertainment': 'TV & Entertainment',
  'smart_home': 'Smart Home',
  'computers': 'Computers',
  'video_games': 'Video Games'
};